import { render, staticRenderFns } from "./FechaTemplate.vue?vue&type=template&id=a74a761c&scoped=true&"
import script from "./FechaTemplate.vue?vue&type=script&lang=js&"
export * from "./FechaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FechaTemplate.vue?vue&type=style&index=0&id=a74a761c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74a761c",
  null
  
)

export default component.exports